import VectorProps from "./VectorProps";

export default function SalesDataIcon(props: VectorProps) {
  const {
    className = "",
    fill = "currentColor",
    handleClick = () => null,
    height,
    width,
  } = props;
  // from https://www.figma.com/design/LyX9wbSKd81UvXFeq58wMx/Foodsteps-Design-Library?node-id=1501-1661&t=UFeJg6a4dH7TnCGj-0
  return (
    <svg
      className={className}
      fill={fill}
      height={height ?? width}
      onClick={handleClick}
      width={width}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23410_749)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 1.6H4C2.67452 1.6 1.6 2.67452 1.6 4V16C1.6 17.3255 2.67452 18.4 4 18.4H16C17.3255 18.4 18.4 17.3255 18.4 16V4C18.4 2.67452 17.3255 1.6 16 1.6ZM4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.2 19V0.5H6.8V19H5.2Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 6.8H0.5V5.2H19V6.8Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_23410_749">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
